// extracted by mini-css-extract-plugin
module.exports = {"spinner":"_2gusO","rotate":"_3S7-o","path":"l_2gT","small":"_20u4y","dash-small":"_2pKfc","dashSmall":"_2pKfc","medium":"_26FYG","dash-medium":"_1B6GB","dashMedium":"_1B6GB"};